import { MaskLines, Overline, Reveal } from "./Motion";
import { WHY, IMG } from "../../lib/site";

const SPANS = [
  "md:col-span-2 lg:col-span-7 lg:row-span-2 min-h-[340px]",
  "lg:col-span-5",
  "lg:col-span-5",
  "lg:col-span-4",
  "lg:col-span-4",
  "md:col-span-2 lg:col-span-4",
];

const Tile = ({ item, i }) => {
  const Icon = item.icon;
  const feature = i === 0;
  return (
    <Reveal delay={(i % 3) * 0.08} data-testid={`why-tile-${i}`}
      className={`group relative overflow-hidden rounded-[24px] border border-white/10 bg-[#131924] p-7 sm:p-8 transition-colors duration-500 hover:border-[#D4AF37]/40 ${SPANS[i]}`}>
      {feature && (
        <>
          <img src={IMG.building} alt="" aria-hidden="true" loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-50 transition-transform duration-[1.4s] group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F17] via-[#0B0F17]/60 to-[#0B0F17]/10" />
        </>
      )}
      <div className={`relative flex h-full flex-col ${feature ? "justify-end" : "justify-between gap-8"}`}>
        <div className="flex items-center justify-between">
          <span className="grid h-12 w-12 place-items-center rounded-2xl border border-[#D4AF37]/30 bg-[#D4AF37]/10 text-[#D4AF37] transition-transform duration-500 group-hover:-rotate-6">
            <Icon className="h-5 w-5" />
          </span>
          {!feature && <span className="font-mono-k text-xs text-slate-400">0{i + 1}</span>}
        </div>
        <div className={feature ? "mt-6" : ""}>
          <h3 className={`font-display font-medium tracking-tight text-white ${feature ? "text-3xl sm:text-4xl" : "text-xl"}`}>{item.title}</h3>
          <p className={`mt-2 leading-relaxed ${feature ? "text-slate-200 max-w-md" : "text-sm text-slate-400"}`}>{item.desc}</p>
        </div>
      </div>
    </Reveal>
  );
};

export const WhyUs = () => (
  <section id="why" data-testid="why-section" className="relative bg-[#0B0F17] py-24 lg:py-36">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Overline>Why Choose Us</Overline>
      <MaskLines className="font-display mt-6 max-w-3xl text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-[-0.03em] leading-[1.02] text-white"
        lines={["Built for the way", <>serious work <span className="text-gold">gets done.</span></>]} />
      <div className="mt-16 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-12 lg:auto-rows-[230px]">
        {WHY.map((item, i) => <Tile key={item.title} item={item} i={i} />)}
      </div>
    </div>
  </section>
);
